import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=9d660214&scoped=true&"
import script from "./CategoryForm.vue?vue&type=script&lang=js&"
export * from "./CategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoryForm.vue?vue&type=style&index=0&id=9d660214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d660214",
  null
  
)

export default component.exports